import { 
	PhoenixTrashItem,
	pxItemTypeGuards,
	ShareBaseDocument,
	ShareBaseFolder, 
	ItemType
} from 'phoenix/domain';

import { Serializable } from 'util/domain';

export class TrashItem extends Serializable<PhoenixTrashItem> {
	public readonly item = (this.source.Embedded.Document || this.source.Embedded.Folder) as ShareBaseDocument|ShareBaseFolder;
	public readonly type = pxItemTypeGuards.isShareBaseDocument(this.item) ? ItemType.Document : ItemType.Folder;
	public readonly itemId = pxItemTypeGuards.isShareBaseDocument(this.item) ? this.item.DocumentId : this.item.FolderId;
	public readonly itemName = this.source.ItemName;
	public readonly deletedBy = this.source.DeletedByUserName;
	public readonly dateDeleted = new Date(this.source.DateDeleted);

	constructor(
		source:PhoenixTrashItem
	){
		super(source);
	}

	public toApi(){
		return this.source;
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/domain/trash-item.ts